import React, { useEffect } from "react";
import Button from "../../../form/Button";
import Editor from "../../../form/Editor";
import useMutation from "../../../../hooks/useMutation";
import { dynamicFieldManage } from "../../../../services/applicationFormService";
import { toast } from "react-toastify";
import useForm from "../../../../hooks/useForm";
import { useNavigate } from "react-router-dom";

const Warnings = ({
  close = () => {},
  continueHandler = () => {},
  data,
  details,
  stepsSlug,
}) => {
  const navigate = useNavigate();
  const validation = {
    applicationInstruction: {
      required: true,
      message: "Application instruction is required",
    },
  };

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({ validationRules: validation });

  const { mutate } = useMutation({
    mutationFn: async () => {
      const payload = {
        formId: details._id,
        groupCode: stepsSlug,
        isRequired: true,
        label:values?.applicationInstruction,
        primaryId: data?.data?.[0]?._id,
        placeholder: "Enter Application Instruction",
        type:"TextArea",
      };

      return await dynamicFieldManage(payload);
    },
    onSuccess: (res) => {
      toast.success(res?.message);
    },
    onError: (error) => {
      console.error("Mutation error:", error);
    },
  });

  useEffect(() => {
    if (data?.data?.[0]?.label) {
      setFieldsValue({
        applicationInstruction: data?.data[0].label,
      });
    }
  }, [data]);

  return (
    <>
      <form onSubmit={(event) => handleSubmit(event, mutate)}>
        <Editor
          label=""
          placeholder="Enter Application Instruction"
          value={values?.applicationInstruction}
          onChange={(val) =>
            handleChange({
              target: { name: "applicationInstruction", value: val },
            })
          }
          {...formValidate(errors, "applicationInstruction")}
        />
        <div className="relative col-span-4 mt-5">
          <div className="flex items-center justify-center gap-4">
          <Button
              buttonLabel={"Save"}
              buttonClasses="!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              buttonLabelClasses="mx-auto"
              buttonType="submit"
             
            />
            <Button
              buttonLabel={"Continue"}
              buttonClasses="!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              buttonLabelClasses="mx-auto"
              buttonType="button"
              buttonFunction={continueHandler}
            />
            <Button
              buttonLabel={"Exit"}
              buttonClasses="!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              buttonLabelClasses="mx-auto"
              buttonFunction={() => navigate("/admin/appform")}
            />
          </div>
        </div>
      </form>
    </>
  );
};

export default Warnings;
